
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Menu } from "lucide-react";
import { ThemeToggle } from "./theme/ThemeToggle";

export const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200">
      <nav className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl font-bold text-black group-hover:opacity-70 transition-opacity">
              doozy
            </span>
          </Link>
          <span className="text-sm text-gray-600 hidden sm:block">
            by <span className="font-semibold">bytehype</span>
          </span>
        </div>
        
        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-medium text-black hover:text-gray-600 transition-colors">
            Home
          </Link>
          <Link to="/tools" className="text-sm font-medium text-black hover:text-gray-600 transition-colors">
            Tools
          </Link>
          <Link to="/pricing" className="text-sm font-medium text-black hover:text-gray-600 transition-colors">
            Pricing
          </Link>
          <Link to="/about" className="text-sm font-medium text-black hover:text-gray-600 transition-colors">
            About
          </Link>
          <Link to="/contact" className="text-sm font-medium text-black hover:text-gray-600 transition-colors">
            Contact
          </Link>
        </div>
        
        <div className="flex items-center gap-3">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon"
                className="md:hidden hover:bg-gray-100 transition-colors"
              >
                <Menu className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent 
              align="end" 
              className="w-56 mt-2 bg-white border-gray-200"
              sideOffset={8}
            >
              <DropdownMenuItem asChild>
                <Link to="/" className="w-full cursor-pointer">
                  Home
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/tools" className="w-full cursor-pointer">
                  Tools
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/pricing" className="w-full cursor-pointer">
                  Pricing
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/about" className="w-full cursor-pointer">
                  About
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/contact" className="w-full cursor-pointer">
                  Contact
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </nav>
    </header>
  );
};
